var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBank(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 60,
    viewBox: "0 0 61 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 60,
    height: 60,
    rx: 30,
    fill: "#F7F8FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31 17L43 23V25.6667H19V23L31 17ZM36.3333 27H41.6667V37.6667H36.3333V27ZM19 43V39H43V43H19ZM28.3333 27H33.6667V37.6667H28.3333V27ZM20.3333 27H25.6667V37.6667H20.3333V27ZM20.3333 40.3333V41.6667H41.6667V40.3333H20.3333ZM21.6667 28.3333V36.3333H24.3333V28.3333H21.6667ZM29.6667 28.3333V36.3333H32.3333V28.3333H29.6667ZM37.6667 28.3333V36.3333H40.3333V28.3333H37.6667ZM20.3333 24.3333H41.6667V23.8L31 18.44L20.3333 23.8V24.3333Z",
    fill: "#0516C8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBank);
export default __webpack_public_path__ + "static/media/bank.a2ba2d77c43131e444c7260353def7b0.svg";
export { ForwardRef as ReactComponent };